import type { CoordenadaFirma } from "@/.shared/.api";

export class DatosCoordenadaFirma implements CoordenadaFirma {
  Pagina: number;
  X: number;
  Y: number;

  constructor(){
    this.Pagina = 1;
    this.X = 0;
    this.Y = 0;
  }
}